<template>
  <ul class="navbar__nav navbar__nav--right">
    <!-- 

    <li class="nav__item">
      <router-link to="/rooms/" class="nav__link nav__link--rounded"
        >Rooms(test)</router-link
      >
    </li>

    <li class="nav__item">
      <router-link
        v-if="Object.keys(this.user).length > 0"
        :to="{ name: 'Room', params: { id: this.user._id } }"
        class="nav__link nav__link--rounded"
        >Chat</router-link
      >
    </li>
    -->
    <li class="nav__item">
      <router-link to="/" class="nav__link nav__link--rounded"
        >🙎🏻‍♀️ Bellas</router-link
      >
    </li>

    <li class="nav__item">
      <router-link to="/voting" class="nav__link nav__link--rounded nav__link--voting"
        ><span class="voting-icon"><ion-icon name="checkbox-outline"></ion-icon></span><span >Vote</span></router-link
      >
    </li>

    <!-- Group Chat - Admin Only -->
    <li v-if="user.isAdmin" class="nav__item">
      <router-link to="/group-chat" class="nav__link nav__link--rounded nav__link--admin"
        ><span class="admin-icon"><ion-icon name="chatbubbles-outline"></ion-icon></span><span >Group Chat</span></router-link
      >
    </li>

    <!-- <li class="nav__item">
      <router-link to="/Chatroom/" class="nav__link nav__link--rounded"
        >Chat</router-link
      >
    </li> -->

    <li class="nav__item">
      <router-link
        v-if="Object.keys(this.user).length > 0"
        :to="{ name: 'UserProfile', params: { handle: this.user.handle } }"
        class="nav__link nav__link--rounded"
        ><ion-icon name="cog-outline"></ion-icon> Profile</router-link
      >
      <!-- {{ this.user.handle }} -->
    </li>
    <li class="nav__item">
      <button
        @click.prevent="logout"
        class="nav__link nav__link--btn nav__link--rounded nav__link--logout"
      >
      <ion-icon name="log-out-outline"></ion-icon>
        Logout
      </button>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SignedInLinks",
  props: ["logout", "user"],
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters(["getUserData", "isAuthorized"]),
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/components/navbar.scss";

.nav__link--logout {
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
}

.nav__link--voting {
  display: flex;
  align-items: center;
  gap: 5px;
  
  @media screen and (max-width: 768px) {
    font-size: 12px;
    
    .voting-text {
      display: none; /* Hide text on mobile, show only icon */
    }
    
    .voting-icon {
      font-size: 16px;
    }
  }
}

.voting-icon {
  font-size: 14px;
}

.voting-text {
  @media screen and (max-width: 480px) {
    display: none; /* Hide text on very small screens */
  }
}

.nav__link--admin {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #007bff;
  
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
}

.admin-icon {
  font-size: 14px;
}
</style>
